import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Introduce',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as {
  content: {
    introduce: string
    advantage: string
    imgList: string[]
  }
};


const productIntroduce = computed(() => props.content?.introduce || '')
const productAdvantage = computed(() => props.content?.advantage || '')
const productImgList = computed(() => props.content?.imgList || [])

return { __sfc: true,props, productIntroduce, productAdvantage, productImgList }
}

})